<template>
  <draggable
    v-model="columns"
    draggable=".column"
    animation="150"
    handle=".drag-handle"
  >
    <div v-for="(column, index) in columns" :key="column" class="column">
      <column
        :columns="columns"
        :column="column"
        :index="index"
        :input-types="$attrs['input-types']"
        :supported-languages="$attrs['supported-languages']"
        :language="$attrs.language"
        :labels="$attrs.labels"
      >
      </column>
    </div>
  </draggable>
</template>

<script>
import Draggable from 'vuedraggable';
import Column from './TableFieldConfiguratorColumn.vue';

export default {
  components: {
    Draggable,
    Column
  },
  inheritAttrs: false,
  props: {
    draggableColumns: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      columns: []
    };
  },
  watch: {
    draggableColumns() {
      this.columns = this.draggableColumns;
    },
    columns() {
      this.$emit('dragging', this.columns);
    }
  },
  created() {
    this.columns = this.draggableColumns;
  }
};
</script>
